import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-report-page-header',
  standalone: true,
  templateUrl: './report-page-header.component.html',
  styleUrl: './report-page-header.component.scss',
})
export class ReportPageHeaderComponent {
  @Input() reportCount = 0;
  @Input() loading = false;
}